import { Component, OnInit } from '@angular/core';
import { Company } from '../../../../models/company';
import { Location } from '../../../../models/location';
import { Region } from '../../../../models/region';
import { Product_Type } from '../../../../models/product_Type';


import { AuthService } from '../../../../services/auth.service';
import { CompanyService } from '../../../../services/company.service';
import { CustomerTypeService } from '../../../../services/customer-type.service';
import { LocationService } from '../../../../services/location.service';
import { PDAUserService } from '../../../../services/pda-user.service';
import { ReportableService } from '../../../../services/reportable.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalService } from '../../../../services/modal.service';

import { saveAs as importedSaveAs } from 'file-saver';

import * as moment from 'moment';
import { Page } from '../../../../models/paging/page';
import { Subject } from 'rxjs';
import { Customer_Type } from '../../../../models/customer_Type';
import { RegionService } from '../../../../services/region.service';
import { ProductTypeService } from '../../../../services/product-type.service';
import { CollectionsDeliveriesService } from '../../../../services/collections-deliveries.service';
import { PDAUser } from '../../../../models/pda_User';
import { CheckUserType } from '../../../../models/checkUserType';
import { ColumnService } from '../../../../services/ColumnService';

@Component({
  selector: 'app-collections-deliveries',
  templateUrl: './collections-deliveries.component.html',
  styleUrls: ['./collections-deliveries.component.css']
})
export class CollectionsDeliveriesComponent implements OnInit {
  role = new CheckUserType();
  client;

  companyService: CompanyService;
  locationService: LocationService;
  modalService: ModalService;

  customerTypes: Customer_Type[];
  users: PDAUser[];

  companies: Company[];
  companyList: Company[];

  locations: Location[];
  locationList: Location[];

  productTypes: Product_Type[];

  filter: any = {
    customer_Type_Id: 0,
    company_Id: 0,
    location_Id: 0,
    pda_User_ID: 0,
    start_Date: moment().add(-2, 'months').toDate(),
    end_Date: moment().toDate(),
    quick_Search: ''
  };

  selectedOptions: string[] = []

  selectedOptionsCollection: string[] = [
    'Cyl Serial #',
    'Cyl Material',
    'Product Type',
    'Cyl Size',
    'In Service',
    'Customer Name',
    'RFID Tag',
    'Fault'
  ];

  selectedOptionsDelivery: string[] = [
    'Cyl Serial #',
    'Cyl Material',
    'Product Type',
    'Cyl Size',
    'In Service',
    'Customer Name',
    'RFID Tag',
    'Fault'
  ];

  availableOptions: string[] = [
    'Cylinder_ID',
    'Cyl Serial #',
    'Cyl Material',
    'Product Type',
    'Cyl Size',
    'In Service',
    'Customer Name',
    'Acc #',
    'Location',
    'Post Code',
    'Valve Serial #',
    'Valve Model #',
    'Owner Name',
    'Cyl Manuf Date',
    'Cyl EOL Date',
    'Cyl Test Date',
    'Valve Manuf Date',
    'Valve EOL Date',
    'Valve Test Date',
    'RFID Tag',
    'Fault'
  ];
  
  distribution_Id: number;
  type: string;
  pageTitle: string;
  pageType: string;
  customerTitle: string;
  dateTitle: string;
  headlineDetails = Array<any>();

  cylinder_Id: string;
  cylinder_Serial_No: string;
  showHistory: boolean = false;
  showEditLocation: boolean = false;

  viewtype: 0;
  page = new Page();
  rows = Array<any>();
  init: boolean;

  constructor(authService: AuthService, companyService: CompanyService, locationService: LocationService, pdaUserService: PDAUserService,
    public collectionsDeliveriesService: CollectionsDeliveriesService, public reportableService: ReportableService,
    customerTypeService: CustomerTypeService, modalService: ModalService, productTypeService: ProductTypeService, public router: Router, private route: ActivatedRoute, 
    private columnService: ColumnService) {
    this.client = authService.currentUser.value;
    this.role.initClient(this.client.role);

    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'desc';
    this.page.sortBy = "";

    productTypeService.getAll().then((data) => {
      this.productTypes = data;
    });

    customerTypeService.getAll().then((data) => {
      this.customerTypes = data;
    });

    companyService.getAll(this.filter.customer_Type_Id).then((data) => {
      this.companyList = data;
      this.companies = this.companyList;

      if (this.role.isStandard || this.role.isMasterStandard || this.role.isAdmin) {
        this.filter.company_Id = this.client.companyId;
      }
      
      locationService.getAll(this.filter.company_Id).then((data) => {
        this.locationList = data;
        this.locations = this.locationList;
      });

      this.loadTable();
    });

    this.companyService = companyService;
    this.locationService = locationService;
    this.modalService = modalService;

    pdaUserService.getAll().then((data) => {
      this.users = data;
    });
  }

  ngOnInit() {
    this.distribution_Id = this.route.snapshot.queryParams.distribution_Id;
    this.type = this.route.snapshot.queryParams.type;
    this.dateTitle = this.route.snapshot.queryParams.date;
    this.updateAvailableColumns()
    this.getcolumns();

    if (this.type.match("D")) {
      this.pageTitle = "Delivery";
      this.pageType = "Deliveries";
    }
    else if (this.type.match("C")) {
      this.pageTitle = "Collection";
      this.pageType = "Collections";
    }

    if (this.distribution_Id != undefined) {
      this.loadTable();
      this.loadHeadlineDetails();
      this.init = true;
    }
  }


  onCompanyChange(value) {
    this.filter.location_Id = 0;
    this.filter.region_Id = 0;
    if (value == 0) { value = null; }

    this.locations = this.locationList.filter(c => {
      return value == null || c.company_Id == value;
    });
  }

  onCustomerTypeChange(value) {
    this.filter.company_Id = 0;
    this.onCompanyChange(0);

    if (value == 0) { value = null; }

    this.companies = this.companyList.filter(c => {
      return value == null || c.customer_Type_Id == value;
    });

  }

  openEditLocationPopup() {
    this.showEditLocation = true;

    this.modalService.open('popup-edit-location');
  }

  closeEditLocationPopup() {
    this.showEditLocation = false;
    this.modalService.close('popup-edit-location');
    location.reload();
  }

  openCylHistoryPopup(row) {
    this.showHistory = true;
    this.cylinder_Id = row.cylinder_ID;
    this.cylinder_Serial_No = row.cyl_Serial_Num;

    this.modalService.open('popup-cyl-history');
  }

  closeCylHistoryPopup(): void {
    if (!this.showHistory) {
      return;
    }
    this.showHistory = false;
    this.modalService.close('popup-cyl-history');
  }

  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable();
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    const sortMapping = {
      'cyl_Manuf_Date_Display': 'cyl_Manuf_Date_Sorting',
      'cyl_EOL_Date_Display': 'cyl_EOL_Date_Sorting',
      'cyl_Last_Test_Date_Display': 'cyl_Last_Test_Date_Sorting',
      'valve_Manuf_Date_Display': 'valve_Manuf_Date_Sorting',
      'valve_EOL_Date_Display': 'valve_EOL_Date_Sorting',
      'valve_Last_Test_Date_Display': 'valve_Last_Test_Date_Sorting',
    };

    const sortBy = sortMapping[event.column.prop] || event.column.prop;

    this.page.sortOrder = event.newValue;
    this.page.sortBy = sortBy;
    this.loadTable();
  }

  loadTable() {
    this.collectionsDeliveriesService.getResults(this.page, this.distribution_Id, this.type, this.filter.quick_Search).then((pagedData) => {
      this.page = pagedData.page;
      this.rows = pagedData.data;

        if (this.init) {
          this.gotoTop();
          this.init = false;
        }
      });
  }

  loadHeadlineDetails() {
    this.collectionsDeliveriesService.getHeadlineDetails(this.distribution_Id).then((details) => {

      const dateStart = moment(details[0].startTime, "YYYY-MM-DDTHH:mm:ss");
      const dateFinish = moment(details[0].finishTime, "YYYY-MM-DDTHH:mm:ss");
      details[0].textDateStart = dateStart.format("DD MMMM YYYY");
      details[0].startTime = dateStart.format("h:mm A");
      details[0].textDateFinish = dateFinish.format("DD MMMM YYYY");
      details[0].finishTime = dateFinish.format("h:mm A");
      this.headlineDetails = details[0];

      if (this.init) {
        this.gotoTop();
        this.init = false;
      }
    });
  }

  onRefresh() {
    this.page.pageNumber = 0;
    this.loadTable();
  }

  downloadReport(id: number) {
    this.reportableService.getDeliveryNotes(id).then((data) => {
      importedSaveAs(data, 'Delivery Notes.pdf'); 
    });
  }

  dateChange(ev) {
    if (ev == -1) {
      return;
    }

    let date = moment();
    if (ev == 0) {
      date = date.subtract(1, 'weeks');
    } else {
      date = date.subtract(ev, 'months');
    }

    let jsDate = date.toDate();
    //var startDate: NgbDateStruct = { year: jsDate.getFullYear(), month: jsDate.getMonth() + 1, day: jsDate.getDate() };
    this.filter.start_Date = jsDate;
  }

  generateExcel() {
    this.collectionsDeliveriesService.getExcel(this.filter.customer_Type_Id, this.filter.company_Id, this.filter.location_Id,
      this.filter.pda_User_ID, this.filter.start_Date, this.filter.end_Date, this.role.isStandard).then((data) => {
        importedSaveAs(data, 'Distributions.xlsx');
      });
  }

  gotoTop() {
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }

  updateAvailableColumns() {
    this.selectedOptions = this.type.match("D") ? this.selectedOptionsDelivery : this.selectedOptionsCollection
  }

  handleSelectedColumns(selectedOptions: string[]): void {
    this.selectedOptions = selectedOptions;
    this.saveSelection();
  }

  getcolumns() {
    console.log("current user", this.client.userId);
    const pageName = this.type.match("D") ? "deliveriesFromDistributions" : "collectionsFromDistributions"
    this.columnService.getColumns(this.client.userId, pageName).then((data) => {
      if (data.columns != null) {
        this.selectedOptions = this.availableOptions.filter(c => {
          return data.columns.includes(c);
        });
      }

    });
  }

  saveSelection() {
    const pageName = this.type.match("D") ? "deliveriesFromDistributions" : "collectionsFromDistributions"
    this.columnService.save(this.client.userId, pageName, this.selectedOptions).then((data) => {
    });
  }
}
